module.exports = __webpack_public_path__ + "static/img/dynamicj.a73bacd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicj.png
// module id = 6Qbh
// module chunks = 45